import { Component } from '@theme/component';

/**
 * Compact size dropdown inside the cart. Delegates swaps to cart-items-component.
 *
 * @extends {Component}
 */
class CartLineVariantPicker extends Component {
  /** @type {AbortController} */
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const select = this.querySelector('[data-cart-variant-select]');
    select?.addEventListener('change', this.#onChange, { signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  /** @param {Event} event */
  #onChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;

    const variantId = select.value;
    const currentVariantId = this.dataset.currentVariantId;

    if (!variantId || variantId === currentVariantId) return;

    const cartItems = this.closest('cart-items-component');
    if (!cartItems || typeof cartItems.changeLineVariant !== 'function') {
      this.#resetSelect(select);
      return;
    }

    const lineKey = this.dataset.lineKey;
    const quantity = Number(this.dataset.quantity);
    const line = Number(this.dataset.line);

    if (!lineKey || !line) {
      this.#resetSelect(select);
      return;
    }

    select.disabled = true;

    cartItems.changeLineVariant({ lineKey, variantId, quantity, line });
  };

  /**
   * @param {HTMLSelectElement} select
   */
  #resetSelect(select) {
    const currentVariantId = this.dataset.currentVariantId;
    if (currentVariantId) {
      select.value = currentVariantId;
    }
    select.disabled = false;
  }
}

if (!customElements.get('cart-line-variant-picker')) {
  customElements.define('cart-line-variant-picker', CartLineVariantPicker);
}